import React from 'react';
import styled from 'styled-components';
import Color from 'color';
import { List, AutoSizer } from 'react-virtualized';
import ClearIcon from '@material-ui/icons/Clear';
import { Typography } from '@material-ui/core';

export const OrderSummaryList = ({ orders, remove, colour }) => {
  const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => {
    const o = orders[index];

    const content = !isScrolling ? (
      <>
        <ListItemContent noWrap>
          <Bold>{o.lastName}</Bold>, {o.firstName} {o.externalID}
        </ListItemContent>
        <RemoveIcon>
          <ClearIcon
            onClick={() => remove(o.externalID)}
          />
        </RemoveIcon>
      </>
    ) : (
      <ListItemContent>Loading</ListItemContent>
    );

    return (
      <ListItem key={key} colour={colour} style={style}>
        {content}
      </ListItem>
    );
  };

  return (
    <AutoSizer>
      {({ height, width }) => (
        <StyledList
          width={width}
          height={height}
          rowCount={orders.length}
          rowHeight={30}
          rowRenderer={rowRenderer}
        />
      )}
    </AutoSizer>
  );
};

const StyledList = styled(List)`
  overflow-y: scroll;
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  text-transform: uppercase;
  color: ${(props) => props.colour};
  border-bottom: 1px solid ${(props) => Color(props.colour).fade(0.75).string()};
  &:first-child {
    border-top: 1px solid ${(props) => Color(props.colour).fade(0.75).string()};
  }
  background-color: ${(props) =>
    props.active
      ? Color(props.colour).fade(0.65).string()
      : Color(props.colour).fade(0.9).string()};
  &:hover {
    background-color: ${(props) => Color(props.colour).fade(0.75).string()};
  }
  &:active {
    background-color: ${(props) => Color(props.colour).fade(0.5).string()};
  }
`;

const ListItemContent = styled(Typography)`
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 10px;
`;

const RemoveIcon = styled.div`
  margin-left: auto;
  font-size: 2rem;
  cursor: pointer;
`;

const Bold = styled.span`
  font-weight: 700;
`;
